import React, {useState} from "react";
import {Page} from "../../components/page/page";
import {ChooseList} from "../../components/choose-list/choose-list";
import {useDispatch} from "react-redux";

const options = [
  {
    title: "Mutual support",
    icon: "🤝",
  },
  {
    title: "Intimacy",
    icon: "💞",
  },
  {
    title: "Safety",
    icon: "🛡️",
  },
  {
    title: "Building a family",
    icon: "👨‍👩‍👧‍👦",
  },
  {
    title: "Emotional connection",
    icon: "💖",
  },
  {
    title: "Fun and adventures",
    icon: "🌍",
  },
];

const RelationshipExpectationsPage = () => {
  const dispatch = useDispatch();
  const [selectedOptions, setSelectedOptions] = useState([]);

  const handleChange = (selectedOptions) => {
    setSelectedOptions(selectedOptions);
  };

  return (
    <Page
      title="What are you looking for in a relationship?"
      nextPageLink="../love-emotion"
      currentStep="6"
      canGoToNextPage={selectedOptions.length >= 1}
      onContinue={() => {
        // dispatch((selectedOptions)); // TODO
      }}
    >
      <ChooseList options={options} maxSelected={6} onChange={handleChange} />
    </Page>
  );
};

export { RelationshipExpectationsPage };
